<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="edit-article-flag-schedule-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Edit Schedule
            </h4>
          </div>

          <div class="modal-body">
            <DateFormGroup
                v-model="data.starts_at"
                name="starts_at"
                label="Starts At"
                help-text="The time that the schedule starts."
                :error="(errors.starts_at || [])[0]"
                format="YYYY-MM-DD HH:mm:ss"
                original-format="YYYY-MM-DD HH:mm:ss"
            />

            <DateFormGroup
                v-model="data.ends_at"
                name="ends_at"
                label="Ends At"
                help-text="The time that the schedule ends."
                :error="(errors.ends_at || [])[0]"
                format="YYYY-MM-DD HH:mm:ss"
                original-format="YYYY-MM-DD HH:mm:ss"
            />
          </div>

          <div class="modal-footer">
            <div class="pull-left">
              <button type="button" class="btn btn-danger" @click="destroy">
                Delete
              </button>
            </div>

            <div class="pull-right">
              <button type="button" class="btn btn-default" data-dismiss="modal">
                Close
              </button>

              <button type="submit" class="btn btn-black">
                <i class="fa fa-save"></i> Save
              </button>
            </div>

            <div class="clearfix"/>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import DateFormGroup from '@/vendor/forms/FormGroups/Block/Date'

export default {
  components: {DateFormGroup},

  mixins: [Errors],

  props: {
    contentArticleFlagSchedule: {
      required: true
    }
  },

  data() {
    return {
      data: {}
    }
  },

  watch: {
    contentArticleFlagSchedule() {
      this.data = {...this.contentArticleFlagSchedule.attributes}
    }
  },

  mounted() {
    this.listenForClose()
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      http.put('/api/v2/content-article-flag-schedules/' + this.contentArticleFlagSchedule.id, this.data)
          .then(response => {
            notify.success('The schedule was saved')

            this.$emit('updated', response.data.data)

            $(this.$el).modal('hide')
          })
          .catch(this.catchValidationErrors)
    },

    destroy() {
      http.delete('/api/v2/content-article-flag-schedules/' + this.contentArticleFlagSchedule.id)
          .then(() => {
            notify.success('The schedule was deleted')

            this.$emit('deleted', this.contentArticleFlagSchedule.id)

            $(this.$el).modal('hide')
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}

      this.data = {...this.contentArticleFlagSchedule.attributes}
    }
  }
}
</script>
